import APIService from 'services/APIService'

const api = APIService()

export const startChat = ({ bpId, question }) =>
  api.post(`/building-passport/${bpId}/guru/chat`, { question })

export const getChatStatus = ({ bpId, messageId }) =>
  api.get(`/building-passport/${bpId}/guru/chat/${messageId}`)

export const confirmAction = ({ bpId, token, edits }) =>
  api.post(`/building-passport/${bpId}/guru/confirm`, { token, edits })

export const confirmPortfolioAction = ({ portfolioId, token, edits }) =>
  api.post(`/portfolios/${portfolioId}/guru/confirm`, { token, edits })

export const confirmEstateAction = ({ estateId, token, edits }) =>
  api.post(`/estates/${estateId}/guru/confirm`, { token, edits })

export const confirmUserAction = ({ token, edits }) =>
  api.post('/guru/confirm', { token, edits })

export const getChatHistory = ({ bpId }) =>
  api.get(`/building-passport/${bpId}/guru/chat/history`)

// Portfolio Guru Chat
export const startPortfolioChat = ({ portfolioId, question }) =>
  api.post(`/portfolios/${portfolioId}/guru`, { question })

export const getPortfolioChatStatus = ({ portfolioId, messageId }) =>
  api.get(`/portfolios/${portfolioId}/guru/status/${messageId}`)

export const getPortfolioChatHistory = ({ portfolioId }) =>
  api.get(`/portfolios/${portfolioId}/guru/history`)

export const startEstateChat = ({ estateId, question }) =>
  api.post(`/estates/${estateId}/guru`, { question })

export const getEstateChatStatus = ({ estateId, messageId }) =>
  api.get(`/estates/${estateId}/guru/status/${messageId}`)

export const getEstateChatHistory = ({ estateId }) =>
  api.get(`/estates/${estateId}/guru/history`)

// Global / across-my-buildings chat (no specific BP or portfolio scope).
export const startUserChat = ({ question }) =>
  api.post('/guru/user-chat', { question })

export const getUserChatStatus = ({ messageId }) =>
  api.get(`/guru/user-chat/${messageId}`)

export const getUserChatHistory = () =>
  api.get('/guru/user-chat/history')

export const getRecommendations = ({ contextType, contextId, surface, subSurface, entityType, entityId }) =>
  api.post('/guru/recommendations', {
    context_type: contextType,
    context_id: contextId,
    surface,
    sub_surface: subSurface || null,
    entity_type: entityType || null,
    entity_id: entityId || null,
  })

export const dismissRecommendation = ({ signature, scope, contextType, contextId }) =>
  api.post(`/guru/recommendations/${signature}/dismiss`, { scope, context_type: contextType, context_id: contextId })

export const getPeekEligibility = ({ contextType, contextId }) =>
  api.get('/guru/peek-eligibility', { params: { context_type: contextType, context_id: contextId } })

export const logPeek = ({ contextType, contextId }) =>
  api.post('/guru/peek-log', { context_type: contextType, context_id: contextId })

export const executeEntityAction = ({ entityType, entityId, ctaKind, payload }) =>
  api.post('/guru/entity-action', { entity_type: entityType, entity_id: entityId, cta_kind: ctaKind, payload })

export const getGuruCapabilities = () => api.get('/guru/capabilities')

export const recordGuruFeedback = ({ rating, answer, question, scopeType, scopeId }) =>
  api.post('/guru/feedback', { rating, answer, question, scopeType, scopeId })

export const getRecommendationSettings = () => api.get('/guru/recommendation-settings')

export const updateRecommendationSettings = body => api.patch('/guru/recommendation-settings', body)
